function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "transparent",
  d: "M0 14C0 6.26801312 6.26801312 0 14 0c7.7319869 0 14 6.26801312 14 14 0 7.7319869-6.2680131 14-14 14-7.73198688 0-14-6.2680131-14-14z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M14.6546943 21v-7.5008782h2.0708706L17 10.9142776h-2.3453057l.0035184-1.29373936c0-.67416717.0640642-1.03540134 1.0325033-1.03540134h1.294624V6h-2.0711638c-2.4878008 0-3.3634422 1.25392752-3.3634422 3.36263929v1.55193111H10v2.5848441h1.550734V21h3.1039603z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-facebook.1d3c5913.svg";
export { SvgComponent as ReactComponent };